<template>
  <div>
    <v-dialog v-model="progressDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>Đang xử lý dữ liệu</v-card-title>
        <v-card-text>
          <v-progress-linear :value="progress" color="blue darken-4" stream></v-progress-linear>
          <div class="progress-text">{{ formattedProgress }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  props: {
    state: Boolean
  },
  watch: {
    state(state) {
      this.progressDialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    },
    progressDialog(value) {
      if (value === true) {
        this.getProgress()
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      progressDialog: false,
      alertShown: false,
      progress: 0,
      formattedProgress: ''
    }
  },
  methods: {
    ...mapActions('lead', ['fetchLeadProgress', 'updateLeadProgress']),
    cancel() {
      this.$emit('closeDialog')
    },
    async getProgress() {
      this.progressDialog = true
      this.updateProgress()
      this.progressInterval = setInterval(() => {
        this.updateProgress()
      }, 5000)
    },

    async updateProgress() {
      const progressData = await this.fetchLeadProgress({})
      if (!progressData) {
        this.progress = 0
        this.formattedProgress = ''
        return
      }
      const {progress, leadCount, totalCount, status} = progressData

      this.progress = progress
      if (status === 'available') {
        this.progress = 0
        this.alertShown = false
      } else if (status === 'creating') {
        if (!this.alertShown) {
          this.$alert.warn('Xin vui lòng đợi để thao tác cũ thực hiện xong')
          this.alertShown = true
        }
        this.formattedProgress = `Đang xử lý ${leadCount}/${totalCount} khách hàng`
      } else if (status === 'finish') {
        this.$loading.active = true
        await this.updateLeadProgress({id: progressData.id, status: 'available'})
        this.formattedProgress = ''

        clearInterval(this.progressInterval)
        this.progressDialog = false
        this.$alert.success('Tạo khách hàng thành công')
        this.$emit('finish', progressData.data)
        this.cancel()
        this.$loading.active = false
      }
    }
  },

  destroyed() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval)
    }
  }
}
</script>
<style scoped>
.progress-text {
  text-align: center;
  margin-top: 10px;
  font-family: 'Roboto';
}
</style>
